module.exports = __webpack_public_path__ + "static/assets/5e8ae4f197c277184f9dd255db7abf53.png";